/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/base/drop-menu/drop-menu');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');

require('./user-list.scss');
const template = require('./user-list.tpl');

const UserList = {
	name: "user-list",

	template,

	data() {
    return {
    	thItems: ["序号", "用户名", "用户ID", "手机号", "是否车主","充电号","所在地",
        "积分","用户标识","用户状态","操作"],
      url: apiPath.user.userList,
      placeItem: '输入用户名',
      forbitLine: '',
      userFlag: [{
        text: "App管理员",
        value: 1
      },{
        text: "cl标识",
        value: 2
      }],
      vertifyBrand: []
    }
	},

  ready() {
    this.queryVertifyBrand();
  },

	methods: {
    qurryUserList() {
      let queryParams = {
        isVertify: this.$refs.vertifyDropmenu.val(),
        userFlag: this.$refs.flagDropmenu.val(),
        keyType: this.$refs.ktypeDropmenu.val(),
        keyWord: this.$refs.kwordInputbox.val()
      };
    	this.$refs.tableData.query(queryParams).fetch();
    },
    queryVertifyBrand() {
      let url = apiPath.user.vertifyBrand;
      this.vertifyBrand.push({
        text: '选择品牌',
        value: -1
      });
      ajaxHttp(url).then((res) => {
        res.data.forEach((item, index) => {
          this.vertifyBrand.push({
            text: item.vertifyBrand,
            value: item.brandId
          })
        })
      }).catch((res) => {
        tip(res.error)
      });
    },
    setForbitDay(index) {
      this.$refs.forbitPop.show();
      this.forbitLine = index;
    },
    cancelForbitUser() {
      let url = apiPath.user.setForbitDay;
      let queryParams = {
        userId: this.$refs.tableData.trItems[this.forbitLine].userId
      }
      ajaxHttp(url, {
        "type": "post",
        "data": queryParams
      }).then((res) => {
        this.$refs.forbitPop.hide();
        this.$refs.tableData.trItems[this.forbitLine].userStatus = 1;
        tip("已解除封禁该用户！")
      }).catch((res) => {
        tip(res.error)
      });
    }
	},

	store,

	events: {
		[dropMenuEvent.menu.change](){
			if ( this.$refs.ktypeDropmenu.val() === 1) {
				this.placeItem = "输入用户名"
			} else if ( this.$refs.ktypeDropmenu.val() === 2 ) {
				this.placeItem = "输入手机号"
			} else if ( this.$refs.ktypeDropmenu.val() === 3 ) {
        this.placeItem = "输入充电号"
      } else if ( this.$refs.ktypeDropmenu.val() === 4 ) {
        this.placeItem = "输入邮箱"
      } else if ( this.$refs.ktypeDropmenu.val() === 5 ) {
        this.placeItem = "输入用户ID"
      }
		}
	},

  filters: {
    changeUserFlag(value) {
      for(let i = 0; i < value.length; i++) {
        for(let j = 0; j < this.userFlag.length; j++) {
          if(value[i] === this.userFlag[j].value) {
            value[i] = this.userFlag[j].text;
          }
        }
        if(value[i] === 0) {
          value = [];
        }
      }
      return value;
    }
  }
}

module.exports = UserList;




// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/user-list/user-list.js